// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import SupportTicketTable from './supportTicket-table';
// assets
//

// ----------------------------------------------------------------------

export default function SupportTickets() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <SupportTicketTable />
        </Container >
    );
}
